import React, { useEffect, useRef, useState } from "react";

import { css, useTheme } from "@emotion/react";
import styled from "@emotion/styled";

import { Link } from "../../../../LinkComponent";
import useNavigationStore from "../../../store";

const SubNavWrapper = styled.div`
    z-index: 100;
    position: absolute;
    padding: 30px;
    background-color: ${({ theme }) => theme.colors.white.toString()};
    top: 60px;
    left: 0;
    right: 0;
    overflow-y: scroll;
    min-height: 180px;
    ${({ theme }) => theme.breakpoints.from.medium.css`
        top: 100%;
        width: fit-content;
        left: unset;
        right: unset;
        overflow-y: unset;
        min-height: unset;
        border-bottom-right-radius: 5px 5px;
        border-bottom-left-radius: 5px 5px;
    `}

    &:hover {
        visibility: visible;
    }
`;

const SubNavContainer = styled.div`
    display: flex;
    flex-direction: column;
    ${({ theme }) => theme.breakpoints.from.medium.css`
       display: grid;
       grid-auto-flow: column;
       grid-column-gap: 80px;
    `}
    position: relative;
`;

const SubNavItems = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

const SubNavHeadline = styled.div`
    margin-bottom: 20px;
    font-weight: 400;
    white-space: nowrap;
    font-size: 18px;
`;

const SubContent = styled.div`
    grid-column-start: 1;
`;

const StyledActiveSpan = styled.span`
    ${({ active }) =>
        active &&
        css`
            border-bottom-style: solid;
            border-bottom-width: 4px;
        `};
`;

const SubNav = ({ subsections, children, isOpen }) => {
    const wrapperRef = useRef(null);
    const [cssCorrection, setCssCorrection] = useState("");
    const theme = useTheme();
    const [activeSubSectionItem] = useNavigationStore((state) => [
        state.activeSubSectionItem,
    ]);
    const subNavLinkItem = css`
        width: 100%;
        font-size: 18px;
        line-height: 2rem;
        font-weight: 500;
        color: ${theme.colors.blue.toString()};
        white-space: nowrap;

        &:hover {
            color: ${theme.colors.blue.toString()};
        }
    `;

    useEffect(() => {
        // Workaround for Mein Konto, where the SubNav will float outside of the screen.
        if (isOpen) {
            const viewportWidth = Math.max(
                document.documentElement.clientWidth || 0,
                window.innerWidth || 0
            );
            const rect = wrapperRef.current.getBoundingClientRect();
            if (rect.right > viewportWidth) {
                setCssCorrection(
                    css`
                        right: 0;
                    `
                );
            }
        }
    }, [isOpen]);

    return (
        <SubNavWrapper ref={wrapperRef} css={cssCorrection}>
            <SubNavContainer>
                {subsections.map((subsection, i) => {
                    return (
                        <SubNavItems key={i}>
                            {subsection.name && (
                                <SubNavHeadline>
                                    {subsection.name}
                                </SubNavHeadline>
                            )}
                            {subsection.items.map((item, i) => (
                                <Link
                                    key={i}
                                    to={item.href}
                                    css={subNavLinkItem}
                                >
                                    <StyledActiveSpan
                                        active={
                                            activeSubSectionItem === item.text
                                        }
                                    >
                                        {item.text}
                                    </StyledActiveSpan>
                                </Link>
                            ))}
                        </SubNavItems>
                    );
                })}
            </SubNavContainer>
            <SubContent>{children}</SubContent>
        </SubNavWrapper>
    );
};

export default SubNav;
